import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import { Switch, useHistory } from 'react-router-dom'
import { ApmRoute } from '@elastic/apm-rum-react'
import Icons from '~/Common-Objects/UI/Icons/index'
import i18n from '~/i18n'
import Mailchimp2 from '~/pages/cp/company/integrations/apps/mailchimp2'
import Mailchimp2Import from '~/pages/cp/company/integrations/apps/mailchimp2/importPage'
import { MAILCHIMP_FLOW_PATH, IMPORT_PROGRESS_PATH } from './paths'
import { leaveMailchimpFlow } from './mailchimpFlowOrigin'

const LEAVE_MS = 280

const prefersReducedMotion = () =>
    typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches

export default function MailchimpFlow() {
    const history = useHistory()
    const [leaving, setLeaving] = useState(false)
    const leavingRef = useRef(false)
    const leaveTimer = useRef(null)

    const close = () => {
        if (leavingRef.current) return
        leavingRef.current = true
        if (prefersReducedMotion()) {
            leaveMailchimpFlow(history)
            return
        }
        setLeaving(true)
        leaveTimer.current = window.setTimeout(() => {
            leaveMailchimpFlow(history)
        }, LEAVE_MS)
    }

    useEffect(() => {
        const previousOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        const onKey = (event) => {
            if (event.key !== 'Escape') return
            if (document.querySelector('.uiDrawer.slideIn')) return
            close()
        }
        window.addEventListener('keydown', onKey)
        return () => {
            document.body.style.overflow = previousOverflow
            window.removeEventListener('keydown', onKey)
            if (leaveTimer.current) window.clearTimeout(leaveTimer.current)
        }
    }, [])

    const flowClass = leaving ? 'mailchimp2-flow mailchimp2-flow--leave' : 'mailchimp2-flow'

    return ReactDOM.createPortal(
        <div className={flowClass}>
            <div className='mailchimp2-flow__backdrop' />
            <div className='mailchimp2-flow__panel'>
                <button
                    type='button'
                    className='mailchimp2-flow__close'
                    onClick={close}
                    aria-label={i18n.t('mailchimp2:close')}
                >
                    <Icons icon='cross' color='#646464' style={{ width: 18, height: 18 }} />
                </button>
                <Switch>
                    <ApmRoute exact path={MAILCHIMP_FLOW_PATH} render={() => <Mailchimp2 onClose={close} />} />
                    <ApmRoute
                        exact
                        path={IMPORT_PROGRESS_PATH}
                        render={() => <Mailchimp2Import onBackground={close} />}
                    />
                </Switch>
            </div>
        </div>,
        document.body
    )
}
